module.exports = __webpack_public_path__ + "static/media/sf-trial-3-incorrect-order.90d54186.mp3";